var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mgr-layout" },
    [
      _c("aside", { staticClass: "mgr-sidebar" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "nav",
          { staticClass: "mgr-nav" },
          [
            _c(
              "router-link",
              {
                staticClass: "mgr-nav-item",
                class: { active: _vm.$route.path === "/manager/users" },
                attrs: { to: "/manager/users" },
              },
              [
                _c("i", { staticClass: "el-icon-user" }),
                _vm._v(" "),
                _c("span", [_vm._v("用户管理")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "mgr-nav-item",
                class: { active: _vm.$route.path === "/manager/logs" },
                attrs: { to: "/manager/logs" },
              },
              [
                _c("i", { staticClass: "el-icon-document" }),
                _vm._v(" "),
                _c("span", [_vm._v("日志管理")]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mgr-sidebar-foot" },
          [
            _c(
              "router-link",
              { staticClass: "mgr-back-link", attrs: { to: "/shicigame" } },
              [
                _c("i", { staticClass: "el-icon-back" }),
                _vm._v(" "),
                _c("span", [_vm._v("返回前台")]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mgr-main" }, [
        _c("header", { staticClass: "mgr-header" }, [
          _c("div", { staticClass: "mgr-header-title" }, [
            _vm._v(_vm._s(_vm.pageTitle)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mgr-header-user" },
            [
              _c("span", { staticClass: "mgr-username" }, [
                _c("i", { staticClass: "el-icon-user-solid" }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.username || "-") +
                    "（" +
                    _vm._s(_vm.username ? "管理员" : "") +
                    "）\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.pwdVisible = true
                    },
                  },
                },
                [_vm._v("修改密码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger", plain: "" },
                  on: { click: _vm.logout },
                },
                [_vm._v("退 出")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("main", { staticClass: "mgr-content" }, [_c("router-view")], 1),
      ]),
      _vm._v(" "),
      _c("manager-password-dialog", {
        attrs: {
          visible: _vm.pwdVisible,
          username: _vm.username,
          "require-old": true,
        },
        on: {
          "update:visible": function ($event) {
            _vm.pwdVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mgr-brand" }, [
      _c("span", { staticClass: "mgr-brand-logo" }, [
        _c("i", { staticClass: "el-icon-monitor" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "mgr-brand-text" }, [_vm._v("后台管理")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }